webpackJsonp([19],{

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(698);


/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var spinner = function spinner() {

    this.initializeLoadingSpinner = function ($spinnerContainer, $spinnerElement, loadingEventId) {
        this.$spinnerContainer = $spinnerContainer;
        this.$spinnerElement = $spinnerElement;
        this.loadingEventId = loadingEventId;

        if (!this.$spinnerElement) {
            this.$spinnerElement = $('<span class="spinner" data-hidden />');
            this.$spinnerContainer.parent().append(this.$spinnerElement);
        }

        this.on(document, 'uiSpinnerShow', this.showSpinner);
        this.on(document, 'uiSpinnerHide', this.hideSpinner);
    };

    this.positionSpinner = function () {
        var spinnerHeight = this.$spinnerElement.outerHeight();
        var spinnerWidth = this.$spinnerElement.outerWidth();
        var containerOffset = this.$spinnerContainer.offset();
        var boxTop = Math.max($(window).scrollTop(), containerOffset.top);
        var boxLeft = Math.max($(window).scrollLeft(), containerOffset.left);
        var boxBottom = Math.min(containerOffset.top + this.$spinnerContainer.outerHeight(), $(window).scrollTop() + $(window).height());
        var boxRight = Math.min(containerOffset.left + this.$spinnerContainer.outerWidth(), $(window).scrollLeft() + $(window).width());

        if (boxBottom - boxTop > spinnerHeight && boxRight - boxLeft > spinnerWidth) {
            this.$spinnerElement.offset({
                top: boxTop + (boxBottom - boxTop - spinnerHeight) / 2,
                left: boxLeft + (boxRight - boxLeft - spinnerWidth) / 2
            });
            return true;
        }

        return false;
    };

    this.isInterestedLoadingEvent = function (loadingEventId) {
        return !loadingEventId || !this.loadingEventId || loadingEventId === this.loadingEventId;
    };

    this.showSpinner = function (e, data) {
        var loadingEventId = data && data.id ? data.id : null;

        if (this.isInterestedLoadingEvent(loadingEventId)) {
            this.$spinnerElement.removeAttr('data-hidden');
            this.$spinnerContainer.addClass('spinner-target');

            if (this.positionSpinner()) {
                this.$spinnerElement.css({ visibility: 'visible' });
            } else {
                this.$spinnerElement.attr('data-hidden', true);
            }
        }
    };

    this.hideSpinner = function (e, data) {
        var loadingEventId = data && data.id ? data.id : null;

        if (this.isInterestedLoadingEvent(loadingEventId)) {
            this.$spinnerContainer.removeClass('spinner-target');
            this.$spinnerElement.css({ visibility: 'hidden' });
            this.$spinnerElement.attr('data-hidden', true);
        }
    };
};

exports.default = spinner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = trackEvent;

var _getExperimentPropertiesForEventPayload = __webpack_require__(67);

//
// Segment analytics event tracking that includes experiment data.
//
// https://segment.com/docs/libraries/analytics.js/
//
function trackEvent(event) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];


    params = _extends({
        url: window.location.href
    }, (0, _getExperimentPropertiesForEventPayload.getExperimentPropertiesForEventPayload)(), params);

    if (false) {
        console.info('Track event: "%s": %o', event, params); // eslint-disable-line no-console
    }

    if (window.analytics) {
        window.analytics.track(event, params, options, callback);
    } else {
        if (typeof callback == 'function') {
            callback();
        }
    }
}

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {

    this.attributes({
        'conditionalItem': '[data-conditional]',
        'filterNameAttr': 'data-conditional-options-filter'
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFilterConditionChanged', this.toggleFilterOptions);
    });

    this.toggleFilterOptions = function (e, data) {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var items;

        if (data.hasOwnProperty(fieldName)) {
            items = this.select('conditionalItem');
            items.each(function (i) {
                if (items.eq(i).attr('data-conditional') === data[fieldName]) {
                    items.eq(i).removeAttr('data-disabled');
                    items.eq(i).removeAttr('data-button-disabled');
                } else {
                    items.eq(i).attr('data-disabled', true);
                    items.eq(i).attr('data-button-disabled', true);
                }
            });
        }
    };
});

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var _asimovDetachedDropdown = __webpack_require__(146);

var _asimovDetachedDropdown2 = _interopRequireDefault(_asimovDetachedDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _flightjs.component)(function () {
    this.attributes({
        'filterNameAttr': 'data-detached-dropdown-filter',
        'detachedDropdown': '[data-detached-dropdown]',
        'filterOptionItem': '[data-detached-dropdown-item]',
        'buttonLabel': '[data-button-label]',
        'buttonCount': '[data-button-count]'
    });

    this.after('initialize', function () {
        _asimovDetachedDropdown2.default.createAll(this.select('detachedDropdown'));

        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);
        this.on('click', {
            'filterOptionItem': this.triggerBrowseFiltersUpdated
        });
    });

    this.triggerBrowseFiltersUpdated = function (e) {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var item = $(e.currentTarget);
        var value = item.attr('data-value');
        var payload = {};

        e.preventDefault();

        if ($(e.currentTarget).attr('data-disabled')) {
            return;
        }

        if (this.$node.data('filterValue') !== value) {
            this.$node.data('filterValue', value);
            payload[fieldName] = value;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);
        var title;
        var value;
        var count;

        if (data.hasOwnProperty(field)) {
            title = '';
            value = data[field];
            this.$node.data('filterValue', value);
            this.select('filterOptionItem').each(function () {
                if ($(this).attr('data-value') === value) {
                    $(this).attr('data-selected', 1);
                    title = $(this).attr('data-title');
                    count = $(this).attr('data-count');
                } else {
                    $(this).removeAttr('data-selected');
                }
            });

            if (title) {
                this.select('buttonLabel').text(title);
            }

            if (count) {
                this.select('buttonCount').text(count);
            }
        }
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {
    this.attributes({
        'select': '[data-styled-select-select]',
        'option': '[data-styled-select-option]',
        'label': '[data-styled-select-label]',
        'count': '[data-styled-select-count]',
        'filterNameAttr': 'data-styled-select-filter'
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFiltersUpdated', this.updateDisplay);

        this.on('change', {
            'select': this.triggerBrowseFiltersUpdated
        });
    });

    this.triggerBrowseFiltersUpdated = function () {
        var fieldName = this.$node.attr(this.attr.filterNameAttr);
        var fieldValue = this.select('select').val();
        var payload = {};

        if (this.$node.data('filterValue') !== fieldValue) {
            this.$node.data('filterValue', fieldValue);
            payload[fieldName] = fieldValue;
            this.trigger('uiBrowseFiltersUpdated', payload);
        }
    };

    this.getTitleByValue = function (value) {
        var title = '';
        this.select('option').each(function () {
            if ($(this).attr('value') === value) {
                title = $(this).attr('data-title');
            }
        });

        return title;
    };

    this.getCountByValue = function (value) {
        var count = '';
        this.select('option').each(function () {
            if ($(this).attr('value') === value) {
                count = $(this).attr('data-count');
            }
        });

        return count;
    };

    this.updateDisplay = function (e, data) {
        var field = this.$node.attr(this.attr.filterNameAttr);

        if (data.hasOwnProperty(field)) {
            this.select('select').val(data[field]);
            this.$node.data('filterValue', data[field]);
            this.select('label').text(this.getTitleByValue(data[field]));

            if (this.getCountByValue(data[field])) {
                this.select('count').text('(' + this.getCountByValue(data[field]) + ')');
            }
        }
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var withHistory = function withHistory() {

    this.isHistoryApiSupported = function () {
        return !!(window.history && history.pushState);
    };

    /**
     * This fires a 'uiHistoryPopped' event upon an onpopstate event on the window object.
     *
     * To address the issue of invalid onpopstate event fired on page load in Webkit browsers, it requires that the
     * current history state has an attribute of 's' of value true. Setting state.s = true marks a page/state as
     * reachable by clicking browser's back button.
     *
     */
    this.registerPopstateListener = function () {
        var existingPopStateListener = window.onpopstate;
        window.onpopstate = function (e) {
            if (window.history.state && window.history.state.s === true) {
                if (existingPopStateListener) {
                    existingPopStateListener();
                }
                this.trigger('uiHistoryPopped');
            }
        }.bind(this);
    };

    this.initializeHistory = function () {
        if (this.isHistoryApiSupported()) {
            this.registerPopstateListener();

            /*
             On initial page load, i.e. user click back button from a different page or user load page using
             browser address bar, the current state is set to null to mark that this page is not affected by
             any onpopstate the browser may or may not fire upon page load.
             */
            window.history.replaceState(null, window.document.title, window.location.href);
        }
    };

    this.pushHistory = function (url) {
        if (this.isHistoryApiSupported()) {

            /*
             Before navigating to a different state, we mark the current state/page reachable by back button
             by assigning state.s == true
             */
            if (!history.state || !history.state.s) {
                window.history.replaceState({ s: true }, window.document.title, window.location.href);
            }

            window.history.pushState({ s: true }, window.document.title, url);
        }
    };
};

exports.default = withHistory;

/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExperimentPropertiesForEventPayload = getExperimentPropertiesForEventPayload;
//
// Helper method for trackEvent, trackLink modules/methods
//
function getExperimentPropertiesForEventPayload() {
  var experimentProperties = {};
  var experiments = window.experiments || {};

  Object.keys(experiments).forEach(function (key) {
    if (key.match(/^experiment_/)) {
      experimentProperties[key] = experiments[key];
    }
  });

  return experimentProperties;
}

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _listingsPane = __webpack_require__(859);

var _listingsPane2 = _interopRequireDefault(_listingsPane);

var _listingsPane3 = __webpack_require__(852);

var _listingsPane4 = _interopRequireDefault(_listingsPane3);

var _nda = __webpack_require__(853);

var _nda2 = _interopRequireDefault(_nda);

var _archive = __webpack_require__(850);

var _archive2 = _interopRequireDefault(_archive);

var _listingsToolbar = __webpack_require__(861);

var _listingsToolbar2 = _interopRequireDefault(_listingsToolbar);

var _header = __webpack_require__(855);

var _header2 = _interopRequireDefault(_header);

var _ndaModal = __webpack_require__(862);

var _ndaModal2 = _interopRequireDefault(_ndaModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
    _listingsPane4.default.attachTo(document);
    _archive2.default.attachTo(document);
    _nda2.default.attachTo(document);

    _listingsPane2.default.attachTo('[data-listings-pane]');
    _listingsToolbar2.default.attachTo('[data-listings-toolbar]');
    _header2.default.attachTo('[data-browse-header]', {
        categoryHeadingMap: window.browseHeaderCategoryMap
    });
    _ndaModal2.default.attachTo('[data-nda-modal]');
});

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {
    this.after('initialize', function () {
        this.on(document, 'uiContestArchiveRequested', this.archive);
        this.on(document, 'uiContestUnarchiveRequested', this.unarchive);
    });

    this.archive = function (e, data) {
        var xhr = $.ajax({
            url: data.endpoint,
            data: data,
            type: 'PUT',
            headers: { 'Accept': 'application/json' }
        });

        xhr.done(function (res) {
            this.$node.trigger('dataContestArchiveSuccess', {
                listingId: data.listingId
            });
        }.bind(this));

        xhr.error(function (res) {
            this.$node.trigger('dataContestArchiveError', {
                listingId: data.listingId
            });
        }.bind(this));
    };

    this.unarchive = function (e, data) {
        var xhr = $.ajax({
            url: data.endpoint,
            data: data,
            type: 'PUT',
            headers: { 'Accept': 'application/json' }
        });

        xhr.done(function (res) {
            this.$node.trigger('dataContestUnarchiveSuccess', {
                listingId: data.listingId
            });
        }.bind(this));

        xhr.error(function (res) {
            this.$node.trigger('dataContestUnarchiveError', {
                listingId: data.listingId
            });
        }.bind(this));
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var _withHistory = __webpack_require__(458);

var _withHistory2 = _interopRequireDefault(_withHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var listingXhr = null;
var countXhr = null;

function contests() {

    this.after('initialize', function () {
        this.initializeHistory();

        this.on(document, 'uiHistoryPopped', this.loadHistoryPage);
        this.on(document, 'uiBrowseLoadContestsRequested', this.loadContests);
        this.on(document, 'uiBrowseLoadCategoryCountRequested', this.loadCategoryCount);
    });

    var categoryParamFilterFunction = function categoryParamFilterFunction(item) {
        return item.name === 'category';
    };

    var visibleParamFilterFunction = function visibleParamFilterFunction(item) {
        var isCategory = item.name === 'category';
        var isDefaultValue = item.value === 'all';
        var isDefaultPage = item.name === 'page' && parseInt(item.value, 10) === 1;

        return !isCategory && !isDefaultValue && !isDefaultPage;
    };

    this.submit = function (url) {
        location.href = url;
    };

    this.getUrl = function (baseUrl, categoryUrl, params) {
        var url, categoryParams, visibleUrlParams;

        categoryParams = $.grep(params, categoryParamFilterFunction);
        visibleUrlParams = $.grep(params, visibleParamFilterFunction);

        if (categoryParams.length === 1 && categoryParams[0].value.toLowerCase() !== 'all') {
            url = categoryUrl.replace('/:category', '/' + categoryParams[0].value);
        } else {
            url = baseUrl;
        }

        return visibleUrlParams.length ? url + '?' + $.param(visibleUrlParams) : url;
    };

    this.getAjaxUrl = function (ajaxUrl, params) {
        return params.length ? ajaxUrl + '?' + $.param(params) : ajaxUrl;
    };

    this.loadContests = function (e, data) {
        var url = this.getUrl(data.url, data.categoryUrl, data.params),
            xhrUrl = this.getAjaxUrl(data.ajaxUrl, data.params);

        this.trigger('dataContestsWillLoad', { url: url });

        this.trigger('uiSpinnerShow');
        if (this.isHistoryApiSupported()) {
            if (listingXhr) {
                listingXhr.abort();
            }

            listingXhr = $.get(xhrUrl);
            listingXhr.done(function (res) {
                this.trigger('dataContestsLoaded', [res]);
                this.trigger('uiSpinnerHide');
            }.bind(this));

            this.pushHistory(url);
        } else {
            this.submit(url);
        }
    };

    this.loadHistoryPage = function () {
        // Note: This is a very cheap way to get the filter elements updated when the back button is click.
        // This need to be refactored to update the page dynamically without an extra page load.
        location.reload();
    };

    this.loadCategoryCount = function (e, options) {
        if (options.path) {
            var url = options.params ? options.path + '?' + $.param(options.params) : options.path;

            if (countXhr) {
                countXhr.abort();
            }

            countXhr = $.ajax(url).done(function (res) {
                this.trigger('dataBrowseCategoryCountLoaded', [res]);
            }.bind(this));
        }
    };
}

exports.default = (0, _flightjs.component)(contests, _withHistory2.default);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {

    this.after('initialize', function () {
        this.on(document, 'uiWatchNdaContestRequested', this.loadNdaModalContent);
        this.on(document, 'uiSignNdaRequested', this.signNda);
    });

    this.loadNdaModalContent = function (e, data) {
        var listingId = data.listingId;
        var contentUrl = data.contentUrl;
        var acceptUrl = data.acceptUrl;
        var xhr = $.get(contentUrl);

        xhr.done(function (res) {
            this.trigger('dataNdaLoaded', { listingId: listingId, content: res, acceptUrl: acceptUrl });
        }.bind(this));
    };

    this.signNda = function (e, data) {
        var url = data.url;
        var listingId = data.listingId;

        var xhr = $.post(url, {
            agreeToCustomNda: data.agreeToCustomNda
        });

        xhr.done(function (res) {
            this.trigger('dataNdaSigned', { listingId: listingId });
        }.bind(this));
        xhr.error(function (res) {
            this.trigger('dataNdaSigningFailed', { listingId: listingId });
        }.bind(this));
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function archiveButton() {
    this.attributes({
        archiveButton: '[data-archive-button-archive]',
        unarchiveButton: '[data-archive-button-unarchive]'
    });

    this.after('initialize', function () {
        this.on('click', this.toggleArchive);
    });

    this.archive = function () {
        this.$node.attr('data-archive-button-state', 'archived');
        this.select('archiveButton').attr('data-hidden', true);
        this.select('unarchiveButton').removeAttr('data-hidden');

        this.trigger(this.$node, 'uiContestArchiveRequested', {
            listingId: this.$node.attr('data-archive-button-listing-id'),
            endpoint: this.$node.attr('data-archive-button-archive-endpoint')
        });
    };

    this.unarchive = function () {
        this.$node.attr('data-archive-button-state', 'unarchived');
        this.select('unarchiveButton').attr('data-hidden', true);
        this.select('archiveButton').removeAttr('data-hidden');

        this.trigger(this.$node, 'uiContestUnarchiveRequested', {
            listingId: this.$node.attr('data-archive-button-listing-id'),
            endpoint: this.$node.attr('data-archive-button-unarchive-endpoint')
        });
    };

    this.toggleArchive = function (e) {
        e.preventDefault();

        if (this.$node.is('[data-archive-button-state="archived"]')) {
            this.unarchive();
        } else {
            this.archive();
        }
    };
}

exports.default = (0, _flightjs.component)(archiveButton);

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {
    this.attributes({
        'title': '[data-header-title]',
        'subtitle': '[data-header-subtitle]',
        'categoryHeadingMap': null
    });

    this.after('initialize', function () {
        this.on(document, 'uiBrowseFiltersUpdated', this.toggleDisplay);
    });

    this.toggleDisplay = function (e, data) {
        if (data.category && this.attr.categoryHeadingMap) {
            var heading = this.attr.categoryHeadingMap[data.category];

            if (heading) {
                this.select('title').text(heading);
                this.select('subtitle').hide();
            }
        }
    };
});

/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var _trackEvent = __webpack_require__(33);

var _trackEvent2 = _interopRequireDefault(_trackEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
// Flight UI component for tracking when listings are in the viewport
//

function inViewportTracker() {

    this.attributes({
        trackableElements: '[data-in-viewport-tracker-element]',
        listingId: 'data-in-viewport-tracker-element-id'
    });

    this.after('initialize', function () {
        var _this = this;

        this.trackedListings = [];
        this.intersectionObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                _this.track(entry.target);
            });
        });

        var trackableNodes = Array.from(document.querySelectorAll(this.attr.trackableElements));

        trackableNodes.forEach(function (node) {
            _this.intersectionObserver.observe(node);
        });
    });

    this.track = function (element) {
        var listingId = element.dataset.inViewportTrackerElementId;
        if (!this.trackedListings.includes(listingId)) {
            (0, _trackEvent2.default)('Viewed Contest Listing', {
                listingId: listingId
            });
            this.trackedListings.push(listingId);
        }
    };

    this.teardown = function () {
        this.intersectionObserver.disconnect();
    };
}

exports.default = (0, _flightjs.component)(inViewportTracker);

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function contestListingPaginator() {
    this.attributes({
        link: 'a:not([data-button-disabled])'
    });

    this.loadPage = function (e, data) {
        e.preventDefault();
        this.trigger('uiBrowseFiltersUpdated', { 'page': $(data.el).data('page') });
    };

    this.after('initialize', function () {
        this.on('click', {
            link: this.loadPage
        });
    });
} //
// Flight UI component for contest listing pagination.
//

exports.default = (0, _flightjs.component)(contestListingPaginator);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 859:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var _flightWithChildComponents = __webpack_require__(162);

var _flightWithChildComponents2 = _interopRequireDefault(_flightWithChildComponents);

var _watchButton = __webpack_require__(863);

var _watchButton2 = _interopRequireDefault(_watchButton);

var _archiveButton = __webpack_require__(854);

var _archiveButton2 = _interopRequireDefault(_archiveButton);

var _withLoadingSpinner = __webpack_require__(242);

var _withLoadingSpinner2 = _interopRequireDefault(_withLoadingSpinner);

var _listingsPagination = __webpack_require__(858);

var _listingsPagination2 = _interopRequireDefault(_listingsPagination);

var _inViewportTracker = __webpack_require__(856);

var _inViewportTracker2 = _interopRequireDefault(_inViewportTracker);

__webpack_require__(339);

__webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function contests() {
    this.childTeardownEvent = 'dataContestsLoaded';

    this.attributes({
        listings: '[data-listings]',
        watchButton: '[data-watch-button]',
        archiveButton: '[data-archive-button]',
        dateTimeItem: '.gmttime',
        paginator: '[data-paginator]'
    });

    this.showContests = function (e, data) {
        // BEFORE
        $('.tooltip').remove();
        this.select('listings').find('[data-tooltip]').remove();

        this.$node.html(data);

        // AFTER
        this.initializeListings();
    };

    this.tooltips = function () {
        $(this.select('listings')).find('[data-tooltip]').tooltip();
    };

    this.initializeListings = function () {
        this.attachChild(_watchButton2.default, this.select('watchButton'));
        this.attachChild(_archiveButton2.default, this.select('archiveButton'));
        this.attachChild(_listingsPagination2.default, this.select('paginator'));
        this.attachChild(_inViewportTracker2.default, this.select('listings'));
        this.select('dateTimeItem').dateTime();
        this.tooltips();
    };

    this.after('initialize', function () {
        this.initializeListings();
        this.initializeLoadingSpinner(this.$node);
        this.on(document, this.childTeardownEvent, this.showContests);
    });
}

exports.default = (0, _flightjs.component)(contests, _flightWithChildComponents2.default, _withLoadingSpinner2.default);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

exports.default = (0, _flightjs.component)(function () {

    this.attributes({
        spinner: '[data-listings-summary-spinner]',
        message: '[data-listings-summary-message]'
    });

    this.after('initialize', function () {
        this.on(document, 'dataContestsLoaded', this.updateResultMessage);
    });

    this.updateResultMessage = function (e, data) {
        var message = $(data).find('#results-message');

        if (message.length) {
            this.select('message').html(message.html());
        }
    };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

var _flightWithChildComponents = __webpack_require__(162);

var _flightWithChildComponents2 = _interopRequireDefault(_flightWithChildComponents);

var _detachedDropdownFilter = __webpack_require__(351);

var _detachedDropdownFilter2 = _interopRequireDefault(_detachedDropdownFilter);

var _listingsSummary = __webpack_require__(860);

var _listingsSummary2 = _interopRequireDefault(_listingsSummary);

var _conditionalOptionsFilter = __webpack_require__(350);

var _conditionalOptionsFilter2 = _interopRequireDefault(_conditionalOptionsFilter);

var _styledSelectFilter = __webpack_require__(352);

var _styledSelectFilter2 = _interopRequireDefault(_styledSelectFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _flightjs.component)(function () {
    this.attributes({
        'listingSummary': '[data-listings-summary]',
        'detachedDropdownFilter': '[data-detached-dropdown-filter]',
        'styledSelectFilter': '[data-styled-select-filter]',
        'conditionalFilter': '[data-conditional-options-filter]'
    });

    this.after('initialize', function () {
        this.initChildComponents();
    });

    this.initChildComponents = function () {
        this.attachChild(_listingsSummary2.default, this.select('listingSummary'));
        this.attachChild(_detachedDropdownFilter2.default, this.select('detachedDropdownFilter'));
        this.attachChild(_conditionalOptionsFilter2.default, this.select('conditionalFilter'));
        this.attachChild(_styledSelectFilter2.default, this.select('styledSelectFilter'));
    };
}, _flightWithChildComponents2.default);

/***/ }),

/***/ 862:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

__webpack_require__(89);

var ndaModal = function ndaModal() {
    this.attributes({
        'agreeForm': '[data-agree-form]',
        'listingIdInput': '[data-listing-id-input]',
        'agreeToCustomNdaCheckbox': '[data-agree-to-custom-nda]',
        'agreeButton': '[data-submit-btn]',
        'ndaContent': '[data-nda-content]',
        'modalTrigger': '[data-modal-name]'
    });

    this.after('initialize', function () {
        this.on(document, 'dataNdaLoaded', this.showNdaModal);
        this.on(document, 'dataNdaSigned', this.closeNdaModal);
        this.on(document, 'dataNdaSigningFailed', this.handleFailure);

        this.on('click', {
            'agreeButton': this.triggerSignNda
        });
    });

    this.showNdaModal = function (e, data) {
        this.select('ndaContent').html(data.content);
        this.select('listingIdInput').val(data.listingId);
        this.select('agreeForm').attr('action', data.acceptUrl);
        this.select('agreeButton').removeAttr('data-button-disabled');

        if (this.select('modalTrigger').data('modal')) {
            this.select('modalTrigger').data('modal').show();
            $('.classic-modal__inner', this.select('modalTrigger').data('modal').$elem).scrollTop(0); // patch Asimov modal
        }
    };

    this.closeNdaModal = function (e, data) {
        if (this.select('modalTrigger').data('modal')) {
            this.select('modalTrigger').data('modal').hide();
        }
    };

    this.handleFailure = function (e, data) {
        this.select('agreeButton').removeAttr('data-button-disabled');
    };

    this.triggerSignNda = function (e) {
        e.preventDefault();
        this.select('agreeButton').attr('data-button-disabled', true);
        this.trigger('uiSignNdaRequested', {
            url: this.select('agreeForm').attr('action'),
            listingId: this.select('listingIdInput').val(),
            agreeToCustomNda: this.select('agreeToCustomNdaCheckbox').prop('checked')
        });
    };
};

exports.default = (0, _flightjs.component)(ndaModal);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),

/***/ 863:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flightjs = __webpack_require__(3);

function watchButton() {
    this.attributes({
        buttonLabel: '[data-button-label]'
    });

    this.after('initialize', function () {
        this.on('click', this.toggleWatch);
        this.on(document, 'dataNdaSigned', this.watchContest);
    });

    this.getWatchActionData = function () {
        return {
            watchingText: this.$node.attr('data-watching-text'),
            watchText: this.$node.attr('data-watch-text'),
            unwatchUrl: this.$node.attr('data-unwatch-url'),
            watchUrl: this.$node.attr('data-watch-url')
        };
    };

    this.showWatching = function (watchData) {
        this.$node.attr('data-button-selected', true);
        this.select('buttonLabel').text(watchData.watchingText);
    };

    this.showWatch = function (watchData) {
        this.$node.removeAttr('data-button-selected');
        this.select('buttonLabel').text(watchData.watchText);
    };

    this.watch = function () {
        var watchData = this.getWatchActionData();

        this.showWatching(watchData);
        $.post(watchData.watchUrl).fail(function () {
            this.showWatch(watchData);
        }.bind(this));
    };

    this.unwatch = function () {
        var watchData = this.getWatchActionData();

        this.showWatch(watchData);
        $.post(watchData.unwatchUrl).fail(function () {
            this.showWatching(watchData);
        }.bind(this));
    };

    this.toggleWatch = function (e) {
        e.preventDefault();

        if (this.$node.is('[data-button-selected]')) {
            this.unwatch();
        } else {
            if (this.$node.is('[data-nda-required]')) {
                this.trigger('uiWatchNdaContestRequested', {
                    listingId: this.$node.attr('data-listing-id'),
                    contentUrl: this.$node.attr('data-nda-content-url'),
                    acceptUrl: this.$node.attr('data-nda-accept-url')
                });
            } else {
                this.watch();
            }
        }
    };

    this.watchContest = function (e, data) {
        if (this.$node.attr('data-listing-id') === data.listingId) {
            this.$node.removeAttr('data-nda-required');
            this.watch();
        }
    };
}

exports.default = (0, _flightjs.component)(watchButton);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })

},[1486]);


// WEBPACK FOOTER //
// browse/layout-dc0899af33afdc2257a9.js